import React, { useState } from 'react';
import { Button, Card, Col, Row, Table } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import PurchaseAddModal from './PurchaseAddModal';
import useFetchDevicePurchaseByEan from '../../hooks/useFetchDevicePurchaseByEan';
import "./DeviceScanControl.css"

interface DeviceDetailsPurchasesProps {
  ean: string;
}

const DeviceDetailsPurchases: React.FC<DeviceDetailsPurchasesProps> = ({ ean }) => {
  const { t } = useTranslation();
  const [showAddPurchase, setShowAddPurchase] = useState(false);
  const { purchaseResponse, error: fetchError, refetch } = useFetchDevicePurchaseByEan({ ean: ean || '' });
  const handleModalClose = () => setShowAddPurchase(false);

  return (
    <>
      <Row className="mt-3">
        <Col>
          <Card className="shadow">
            <Card.Header className="d-flex justify-content-between align-items-center pt-3 bg-primary border-bottom">
              <Card.Title className="position-relative top-0 start-50 translate-middle-x fs-4 text-white fw-semibold">{t("devices.purchases.title")}</Card.Title>
              <Button type='submit' className="button-scan" onClick={() => setShowAddPurchase(!showAddPurchase)}>
                <FontAwesomeIcon icon={faPlus} /> {t("add")}
              </Button>
            </Card.Header>
            <Table responsive hover striped className="text-center position-static top-50 start-50 mx-4 mt-3" style={{ width: "95%" }}>
              <thead className='table-light' key="header-purchases">
                <tr className='fs-5 text-nowrap'>
                  <th className="p-2 bg-primary text-white fw-semibold rounded-3 rounded-bottom-0 rounded-end-0 px-5">{t("devices.purchases.hash")}</th>
                  <th className="p-2 bg-primary text-white fw-semibold px-5">{t("type")}</th>
                  <th className="p-2 bg-primary text-white fw-semibold px-5">{t("devices.purchases.targetDevice")}</th>
                  <th className="p-2 bg-primary text-white fw-semibold px-5">{t("devices.purchases.purchasedDate")}</th>
                  <th className="p-2 bg-primary text-white fw-semibold rounded-3 rounded-bottom-0 rounded-start-0 px-5">{t("devices.purchases.activationDate")}</th>
                </tr>
              </thead>
              <tbody>
                {purchaseResponse?.map(purchase => (
                  <tr key={purchase.id}>
                    <td className='text-light-emphasis fw-medium'>{purchase.hash}</td>
                    <td className='text-light-emphasis fw-medium'>{purchase.type?.name}</td>
                    <td className='text-light-emphasis fw-medium'>{purchase.targetDevice?.ean}</td>
                    <td className='text-light-emphasis fw-medium'>{purchase.purchaseDate?.toLocaleString()}</td>
                    <td className='text-light-emphasis fw-medium'>{purchase.activationDate?.toLocaleString()}</td>
                  </tr>
                ))}

                {(!purchaseResponse || purchaseResponse?.length === 0) && (
                  <tr>
                    <td colSpan={5} className='py-3'>{t("devices.purchases.noPurchase")}</td>
                  </tr>
                )}
              </tbody>
            </Table>
          </Card>
        </Col>
      </Row>
      {showAddPurchase && purchaseResponse && (
        <PurchaseAddModal ean={ean} show={showAddPurchase} handleClose={handleModalClose} onSuccess={refetch} />
      )}
    </>
  );
};

export default DeviceDetailsPurchases;
